// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"cebef353","98":"2de91dea","142":"62e325ed","255":"1ec1a717","328":"20de56b2","350":"2c702889","387":"ebbe5c34","652":"116469f5","671":"9300f2c0","680":"533b228c","723":"d3455403","867":"08cfa991","923":"77473215"}[chunkId] + ".chunk.js";
};